// @flow

import type { Platform, Marketplace, Publish } from '../public/type'

import config from './config'

export function isValidPlatform (platform: string) {
  return ['h5', 'app', 'pc', 'appNative'].indexOf(platform) > -1
}

export function platformToCatrgory (platform: Platform): string {
  switch (platform) {
    case 'h5':
      return 'easy'
    case 'app':
      return 'appe'
    case 'pc':
      return 'pce'
    case 'miniPro':
      return 'miniPro'
    case 'appNative':
      return 'appNative'
    default:
      throw new Error('platform must be h5, app , pc or all')
  }
}

export function codeToPlatform (code: string): Platform {
  switch (code.split('-')[1]) {
    case 'easy':
      return 'h5'
    case 'appe':
      return 'app'
    case 'pce':
      return 'pc'
    case 'miniPro':
      return 'miniPro'
    case 'appNative':
      return 'appNative'
    default:
      throw new Error(`code is wrong, code: ${code}`)
  }
}

export function getMarketplaceName (marketplace: Marketplace): string {
  switch (marketplace) {
    case 'ydd':
      return '喜鹊快贷'
    case 'abroad':
      return '海外'
    default:
      return '凤凰金融'
  }
}

export function getPublishName (publish: Publish): string {
  switch (publish) {
    case 'draft':
      return '未发布'
    case 'published':
      return '已发布'
    case 'deleted':
      return '已删除'
    default:
      return '全部'
  }
}

const urlString: {
  [Marketplace]: {
    [Platform]: string | { serverRenderUrl: string, url: string }
  }
} = {
  fengjr: {
    h5: {
      serverRenderUrl: `${config.hostFengjr}/cn/cms/`,
      url: `${config.hostFengjr}/cn/flow/cms/`
    },
    pc: `${config.hostFjpc}/cn/pc/cms/`
  },
  abroad: {
    h5: `${config.hostAbroadH5}/gblwx/flow/cms/`,
    pc: `${config.hostAbroadPc}/gblwx/flow/cms/`
  },
  ydd: {
    h5: `${config.hostFengjr}/cn/flow/cms/magpie/`,
    pc: `${config.hostFengjr}/cn/pc/cms/`
  }
}

export function getOnlineUrl (
  code: string,
  platform: Platform,
  marketplace: Marketplace = 'fengjr',
  serverRender?: boolean
): string {
  const urlObj = urlString[marketplace] && urlString[marketplace][platform]
  let url
  if (typeof urlObj === 'object') {
    url = serverRender ? urlObj.serverRenderUrl : urlObj.url
  } else {
    url = urlObj
  }
  return (url || '') + code
}



// WEBPACK FOOTER //
// ./src/projects/easy/lib/platform.js